<app-page-shell [breadcrumb]="breadcrumb" width="wide">
  <header class="mx-auto max-w-4xl px-6 pt-12 pb-10 text-center md:pt-16">
    <p class="mb-4 eyebrow">{{ 'pages.regbr.hero.eyebrow' | transloco }}</p>
    <h1
      class="hero-title font-display text-4xl font-bold leading-[1.06] text-foreground md:text-[3.25rem]"
    >
      <span>{{ 'pages.regbr.hero.titlePrefix' | transloco }}</span>
      <span class="hero-title-accent italic font-medium text-primary">{{
        'pages.regbr.hero.titleAccent' | transloco
      }}</span>
    </h1>
    <p
      class="mx-auto mt-6 max-w-3xl text-base leading-relaxed text-muted-foreground md:text-[17px]"
    >
      {{ 'pages.regbr.hero.description' | transloco }}
    </p>
  </header>

  <div class="container mx-auto max-w-7xl px-6 pb-24">
    <app-regbr-tabs />

    <section class="mt-10 space-y-4 text-[15px] leading-relaxed text-muted-foreground">
      <p [innerHTML]="'pages.regbr.metrics.update' | transloco"></p>
      <p>{{ 'pages.regbr.metrics.description' | transloco }}</p>
    </section>

    <div class="mt-10">
      <app-regbr-metric-nav />
    </div>

    <div class="mt-10">
      <router-outlet />
    </div>
  </div>
</app-page-shell>
